import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface LatestComicsProps {
  comics: Comic[];
}

export default function LatestComics({ comics }: LatestComicsProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">最新上架</h2>
            <p className="text-sm text-foreground-500 mt-2">每日更新，精彩不容错过</p>
          </div>
          <Link to="/category/fantasy" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
            查看全部 <i className="ri-arrow-right-line ml-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {comics.map(comic => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex gap-4 bg-background-50 rounded-xl p-4 hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg w-[100px] h-[140px] flex-shrink-0 bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  title={`${comic.title} - 韩国漫画在线阅读`}
                />
              </div>
              <div className="flex flex-col justify-between py-1 min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">作者：{comic.author}</p>
                  <div className="flex items-center gap-2 mt-2 flex-wrap">
                    {comic.tags.slice(0, 2).map(tag => (
                      <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs" />
                    </div>
                    <span className="text-xs text-foreground-500">{comic.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">
                    {comic.status === '连载中' && (
                      <span className="text-accent-600">更新至 {comic.chapters.length} 话</span>
                    )}
                    {comic.status === '已完结' && (
                      <span className="text-secondary-500">共 {comic.chapters.length} 话 · 已完结</span>
                    )}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}